export default "__VITE_ASSET__2006cbf9__"